import axios, { AxiosInstance } from 'axios';
import { IBlockchainEntity } from '@ankr.com/chains-list';

import { AXIOS_DEFAULT_CONFIG } from '../common';
import { Config, INodesDetailEntity, IRate } from './types';
import {
  IUsageDataMRPCRequestBodyParams,
  IUsageDataMRPCRequestQueryParams,
  IUsageDataMRPCResponse,
} from '../worker';

export class PublicGateway {
  public api: AxiosInstance;

  public accountApi: AxiosInstance;

  constructor(private readonly config: Config) {
    const { workerUrl, accountUrl } = config;

    this.api = axios.create({
      ...config,
      ...AXIOS_DEFAULT_CONFIG,
      baseURL: workerUrl,
    });

    this.accountApi = axios.create({
      ...config,
      ...AXIOS_DEFAULT_CONFIG,
      baseURL: accountUrl,
    });
  }

  async getBlockchains(): Promise<IBlockchainEntity[]> {
    const { data } = await this.api.get<IBlockchainEntity[]>(
      '/api/v1/blockchain',
    );

    return data;
  }

  async getNodesDetail(): Promise<INodesDetailEntity[]> {
    const { data } = await this.api.get<INodesDetailEntity[]>(
      '/api/v1/blockchain/detail',
    );

    return data;
  }

  public async getSharkTelemetry(
    body: IUsageDataMRPCRequestBodyParams,
    params: IUsageDataMRPCRequestQueryParams,
  ): Promise<IUsageDataMRPCResponse> {
    const { data: response } = await this.api.post<IUsageDataMRPCResponse>(
      '/api/v2/telemetry/usage-data',
      body,
      { params },
    );

    return response;
  }

  async getRate(): Promise<IRate> {
    const { data } = await this.accountApi.get<IRate>('/api/v1/rate');

    return data;
  }

  async getOpenAPIDocumentJSON() {
    const { data } = await this.accountApi.get<Blob>('/swagger.json', {
      responseType: 'blob',
    });

    return data;
  }

  async getOpenAPIDocumentYAML() {
    const { data } = await this.accountApi.get<Blob>('/swagger.yaml', {
      responseType: 'blob',
    });

    return data;
  }
}
